/*
 * WCBJ native "Pouch & sterilize" add-on — replaces the Avis Product Options app.
 *
 * How it works:
 *  - A checkbox in the product form (snippets/sterilize-option.liquid) enables a
 *    hidden line-item property `Pouch and sterilize: Yes` on the item being added.
 *  - This script keeps ONE consolidated charge line in the cart whose quantity
 *    always equals the total quantity of every item flagged for sterilizing,
 *    priced at the charge variant's price ($0.50 each). It recomputes from the
 *    cart itself on every cart update, so it self-heals through quantity edits,
 *    removals, and multiple sterilized products.
 *
 * Safety: the source of truth is the server cart. Even if a visual re-render is
 * missed, the charge line is correct, so checkout always bills correctly.
 *
 * Depends only on Dawn globals that load before it: `subscribe`,
 * `PUB_SUB_EVENTS`, `routes`. Charge variant id is injected as
 * `window.STERILIZE_CHARGE_VARIANT` by layout/theme.liquid.
 */
(function () {
  'use strict';

  var PROP = 'Pouch and sterilize';

  // ---- checkbox -> hidden property (works even if the charge id is missing) ----
  document.addEventListener('change', function (e) {
    var cb = e.target && e.target.closest ? e.target.closest('.js-sterilize-toggle') : null;
    if (!cb) return;
    var wrap = cb.closest('.sterilize-option');
    if (!wrap) return;
    var prop = wrap.querySelector('.js-sterilize-prop');
    if (prop) prop.disabled = !cb.checked;
  });

  var CHARGE = window.STERILIZE_CHARGE_VARIANT;
  if (!CHARGE) return; // feature disabled or charge product unavailable

  var busy = false;

  function url(key, fallback) {
    return (window.routes && window.routes[key]) || fallback;
  }

  function renderTargets() {
    var t = [];
    var items = document.getElementById('main-cart-items');
    if (items && items.dataset.id) t.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
    var footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset.id) t.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
    if (document.querySelector('cart-drawer')) t.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });
    if (document.getElementById('cart-notification')) t.push({ id: 'cart-notification', section: 'cart-notification', selector: '.cart-notification-wrapper' });
    if (document.getElementById('cart-icon-bubble')) t.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    return t;
  }

  function applySections(sections) {
    if (!sections) return;
    renderTargets().forEach(function (t) {
      var html = sections[t.section];
      if (!html) return;
      var container = document.getElementById(t.id);
      if (!container) return;
      var dest = container.querySelector(t.selector) || container;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var src = parsed.querySelector(t.selector) || parsed.body;
        if (src && dest) dest.innerHTML = src.innerHTML;
      } catch (e) {
        /* benign: server cart is still correct */
      }
    });
  }

  function post(u, body) {
    return fetch(u, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  function reconcile() {
    if (busy) return;
    busy = true;
    fetch(url('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var desired = 0;
        var charge = null;
        (cart.items || []).forEach(function (it) {
          if (it.variant_id === CHARGE) { charge = it; return; }
          if (it.properties && it.properties[PROP] === 'Yes') desired += it.quantity;
        });
        var sections = renderTargets().map(function (s) { return s.section; });
        var common = { sections: sections, sections_url: window.location.pathname };
        if (desired > 0 && !charge) {
          return post(url('cart_add_url', '/cart/add'), Object.assign({ items: [{ id: CHARGE, quantity: desired }] }, common));
        }
        if (charge && charge.quantity !== desired) {
          // Use the line-item key (unambiguous) to set the absolute quantity;
          // quantity 0 removes the line when no sterilized items remain.
          return post(url('cart_change_url', '/cart/change'), Object.assign({ id: charge.key, quantity: desired }, common));
        }
        return null; // already in sync
      })
      .then(function (res) { if (res && res.sections) applySections(res.sections); })
      .catch(function () { /* leave cart untouched on error */ })
      .then(function () { busy = false; });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { reconcile(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
